import { render, staticRenderFns } from "./dettaglioCustom.vue?vue&type=template&id=85d0ec48"
import script from "./dettaglioCustom.vue?vue&type=script&lang=js"
export * from "./dettaglioCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports